<template>
  <form
    id="spotify-search-tracks-form"
    method="post"
    @submit.prevent="onSearch"
  >
    <mj-input-field
      id="search"
      v-model="searchQuery"
      placeholder="Suche hier starten..."
      autocomplete="off"
      class="px-6"
      @input="onSearch"
    />
  </form>
</template>

<script>
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
import debounce from 'lodash.debounce';
import SpotifyService from '@/services/api/SpotifyService';

export default {
  name: 'SpotifySearchTracks',

  data() {
    return {
      searchQuery: null,
    };
  },

  methods: {
    // eslint-disable-next-line func-names
    onSearch: debounce(function () {
      if (this.searchQuery.length <= 0) {
        this.$emit('found-tracks', []);
        return;
      }
      SpotifyService.serach(this.searchQuery)
        .then(data => {
          this.$emit('total', data.tracks.total);
          this.$emit('found-tracks', data.tracks.items);
          this.$emit('next-tracks', data.tracks.next);
        });
    }, 1000),
    test() {
      (debounce(function () {
        // debounce(function () {
        //   console.log('debounce');
        // }, 1000);
      }, 2000))();
    },
  },

};
</script>
